module.exports = __webpack_public_path__ + "static/media/PT.55a651f8.svg";